import React from 'react';
import PropTypes from 'prop-types';
import {withFloatRightToCenter} from '@/hocs/withAlignment';
import Link from '@/links';
import cx from 'classnames';

import AppStore from '@/svg/download-app-icons/app-store';
import GooglePlay from '@/svg/download-app-icons/google-play';

import styles from './styles.module.scss';

const propTypes = {
  variant: PropTypes.string
};

const AppLogosWrap = withFloatRightToCenter('div');

const AppBadges = ({variant}) => {
  const classes = cx({
    [styles['app-badges']]: true,
    [styles[`app-badges-${variant}`]]: variant !== null
  });

  return (
    <AppLogosWrap className={classes}>
      <ul>
        <li>
          <Link
            href="//itunes.apple.com/us/app/workablehr/id1164841670?ls=1&mt=8"
            title="Download Workable on App Store"
            target="_blank"
            rel="noopener">
            <div className={styles['app-badge']}>
              <AppStore />
            </div>
          </Link>
        </li>
        <li>
          <Link
            href="//play.google.com/store/apps/details?id=com.workable.ats"
            title="Download Workable on Google Play"
            target="_blank"
            rel="noopener">
            <div className={styles['app-badge']}>
              <GooglePlay />
            </div>
          </Link>
        </li>
      </ul>
    </AppLogosWrap>
  );
};

AppBadges.propTypes = propTypes;

export default AppBadges;
